// extracted by mini-css-extract-plugin
export default {"container":"ButtonPage_container_PUfVX","card":"ButtonPage_card_rOVgS","btnTitle":"ButtonPage_btnTitle_OAs4K"};